/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col, Spinner,
} from "reactstrap";

// core components

// index page sections


import {RiAddLine, RiHeartFill, RiSettings3Line} from "react-icons/ri";
import withNavigateHook from "../../hooks/withNavigationHook";
import {useParams} from "react-router-dom";
import {sessionEnded} from "./SessionEnded";
import {
  getSongBookPreferences, getThemePreferences,
  saveSongBookPreferences,
  saveThemePreferences
} from "../../components/helpers/UserPreferenceHelpers";
import ThemesDropdown from "../themes/ThemesDropdown";
import {RiDeleteBin6Line} from "@remixicon/react";
import Api from "../../components/helpers/Api";
import SeoNoIndex from "../../components/helpers/SeoNoIndex";

class YourPreferencesThemes extends React.Component {
  state = {
    songBookCount: null,
    isLoading: false,
    listItems: [],
    themeSelected: null,
    chosenThemeButtons: null,
  };

  componentDidMount() {
    sessionStorage.removeItem("selected-themes");

    const selectedSongBooks = sessionStorage.getItem("selected-song-books") == null ? [] : JSON.parse(sessionStorage.getItem("selected-song-books"));
    const preferredSongBooks = sessionStorage.getItem("preferred-song-books") == null ? [] : JSON.parse(sessionStorage.getItem("preferred-song-books"));
    const requestedSongBookIds = [...selectedSongBooks,...preferredSongBooks].map(songBook =>{
      return songBook.id
    })

    this.setState({isLoading: true});
    Api.get(`/themes`)
        .then(res => {
          const listItems = res.data;
          sessionStorage.setItem("themes", JSON.stringify(listItems));
          this.setState({listItems: listItems});
          this.setState({isLoading: false});
        })

    // This `if` statement is causing problems on reloading after deletion!
    // if (!sessionStorage.getItem("preferred-song-books")) {
    //   getSongBookPreferences().then(res => {
    //     sessionStorage.setItem("preferred-song-books", JSON.stringify(res));
    //    });
    // }

    // This `if` statement is causing problems on reloading after deletion!
    // if (!sessionStorage.getItem("preferred-themes")) {
      getThemePreferences().then(res => {
        sessionStorage.setItem("preferred-themes", JSON.stringify(res));
    // }

        const preferredThemes = this.props.sessionPropName !== "preferred-themes" && sessionStorage.getItem("preferred-themes") ? JSON.parse(sessionStorage.getItem("preferred-themes")) : [];
        const preferredThemeIds = sessionStorage.getItem("preferred-themes") ? JSON.parse(sessionStorage.getItem("preferred-themes")).map(psb => psb.id) : [];
        const themes = sessionStorage.getItem(this.props.sessionPropName) == null ? [...preferredThemes] : [...JSON.parse(sessionStorage.getItem(this.props.sessionPropName)), ...preferredThemes];
        this.setState({
          chosenThemeButtons: themes
              .sort((a, b) => a.title > b.title ? 1 : -1)
              .map((theme, index) => {
                return this.showPill(index, theme, preferredThemeIds);
              })
        })
      });
  }

  enableActiveButtonHandler = (enable) => {
    this.setState({activeButtonActive: enable});
    this.continueButtonAvailable();

    this.forceUpdate();
  }

  continueButtonAvailable = () => {
    sessionStorage.setItem("songBooksContinueEnabled", sessionStorage.getItem("selected-song-books") && JSON.parse(sessionStorage.getItem("selected-song-books")).length > 0);
  }

  updateSongBookPreferences = () => {
    saveSongBookPreferences(JSON.parse(sessionStorage.getItem("preferred-song-books")).map(psb => psb.id)).then(() => {
      this.props.navigation(0);
    });
  }

  updateThemePreferences = () => {
    saveThemePreferences(JSON.parse(sessionStorage.getItem("preferred-themes")).map(psb => psb.id)).then(() => {
      this.props.navigation(0);
    });
  }
  
  changeThemeHandlerFrom = (event) => {
    if (event.target.value.toUpperCase().indexOf("THEME")) { // i.e. not first option in list
      const theme = this.state.listItems.filter(b => b.id === event.target.value)[0];
      this.setState({themeSelected: theme});
    } else {
      this.setState({themeSelected: null});
    }
  };

  addButtonAvailable = () => {
    return this.state.themeSelected != null &&
        ((!sessionStorage.getItem("customer") && JSON.parse(sessionStorage.getItem("preferred-themes"))?.length !== 1) ||
            (sessionStorage.getItem("customer")));
  }

  getAllSelected = () => {
    return sessionStorage.getItem("preferred-themes") === null ? [] : JSON.parse(sessionStorage.getItem("preferred-themes"));
  }

  addThemeToList = () => {
    const allSelected = this.getAllSelected();
    const alreadyExists = allSelected.filter(sb => sb.id === this.state.themeSelected.id).length > 0;
    if (this.addButtonAvailable && !alreadyExists) {
      const themes = sessionStorage.getItem("preferred-themes" == null) ? [] : JSON.parse(sessionStorage.getItem("preferred-themes"));
      const theme = {
        id: this.state.themeSelected.id,
        title: this.state.themeSelected.title
      };
      themes.push(theme);
      sessionStorage.setItem("preferred-themes", JSON.stringify(themes));

      this.updateThemePreferences();

      const preferredThemeIds = sessionStorage.getItem("preferred-themes") ? JSON.parse(sessionStorage.getItem("preferred-themes")).map(psb => psb.id) : [];

      // this.setState({
      //   chosenThemeButtons: themes
      //       .sort((a, b) => a.title > b.title ? 1 : -1)
      //       .map((theme, index) => {
      //         return this.showPill(index, theme, preferredThemeIds);
      //       })
      // })

      this.enableActiveButtonHandler(true);
      sessionStorage.setItem("themeContinueEnabled", true);
    }
  }

  removePill = (theme) => {
    let updatedThemes = sessionStorage.getItem("preferred-themes") === null ? null : JSON.parse(sessionStorage.getItem("preferred-themes")).filter(t => t.id !== theme.id);
    if (updatedThemes === null) {
      sessionStorage.removeItem("preferred-themes");
    } else {
      sessionStorage.setItem("preferred-themes", JSON.stringify(updatedThemes));
    }

    // Check preferred themes
    const foundInPreferredThemes = sessionStorage.getItem("preferred-themes") === null ? null : JSON.parse(sessionStorage.getItem("preferred-themes")).filter(sb => sb.id === theme.id);
    if (foundInPreferredThemes != null) {
      sessionStorage.setItem("preferred-themes", JSON.stringify(JSON.parse(sessionStorage.getItem("preferred-themes")).filter(sb => sb.id !== theme.id)));
    }

    this.updateThemePreferences();
    this.componentDidMount();
    this.enableActiveButtonHandler(true);
  }

  showPill = (index, theme, preferredThemeIds) => {
    const showDeleteOption = window.location.pathname.includes("your-preferences");
    return (
        <div className="col-md-3 col-xs-12">
          <Button className='text-uppercase mx-2' color="primary" size="sm" style={{margin: '4px', width: "95%"}} onClick={this.addButtonAvailable} title={theme.title}>
                    <span style={{fontSize:"0.6rem"}}>
                        {theme.title.length <= 22 ? theme.title : theme.title.substring(0,19) + "..."}
                    </span>&nbsp;
            {preferredThemeIds && preferredThemeIds.filter((val) => val.includes(theme.id)).length >= 1
                ? showDeleteOption
                    ? <><a href="" title={"Remove " + theme.title + " from selected themes"} onClick={() => this.removePill(theme)} className="btn-inner--icon ml-1 mr-1" style={{verticalAlign:"top"}}><RiDeleteBin6Line size={18} style={{color:"white", float:"right"}}/><RiHeartFill size={18} style={{color:"white", float: "left"}}/></a></>
                    : <><RiHeartFill size={18} style={{color:"white", float: "right"}}/></>
                : <><a href="" title={"Remove " + theme.title + " from selected themes"} onClick={() => this.removePill(theme)} className="btn-inner--icon ml-1 mr-1" style={{verticalAlign:"top"}}><RiDeleteBin6Line size={18} style={{color:"white", float:"right"}}/></a></>
            }
          </Button>
        </div>);
  }

  getThemeOptions() {
    const selectedThemeIds = sessionStorage.getItem("selected-themes") ? JSON.parse(sessionStorage.getItem("selected-themes")).map(psb => psb.id) : [];
    const preferredThemeIds = sessionStorage.getItem("preferred-themes") ? JSON.parse(sessionStorage.getItem("preferred-themes")).map(psb => psb.id) : [];

    return <>
      this.currentTestament = "";
      {
        this.state.listItems.map((listItem, index, array) => {
          const disabled = [...selectedThemeIds,...preferredThemeIds].filter((val) => val.includes(listItem.id)).length >= 1;
          var option = <option disabled={disabled} key={listItem.id} className="dropdown-item" value={listItem.id}>{listItem.title}</option>;
          return <React.Fragment>
            {option}
          </React.Fragment>
        })
      }
    </>;
  }

  render() {
    if (!sessionStorage.getItem("customer")) {
      return sessionEnded();
    }

    return (
      <>
        <SeoNoIndex noindex={true} />

        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>your preferences</span>
                      </h1>
                      {/*<p className="lead text-white">*/}
                      {/*  The design system comes with four pre-built pages to*/}
                      {/*  help you get started faster. You can change the text and*/}
                      {/*  images and you're good to go.*/}
                      {/*</p>*/}
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="12">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                            <RiSettings3Line color='#5e72e4' size="36"/>&nbsp;Your theme preferences
                          </h2>
                          <p className="description mt-3">
                            Personalise your song-flow creation by managing your theme preferences
                          </p>
                          <p className="description mt-3">
                            {/*<ThemesDropdown key={new Date()}*/}
                            {/*                   enableActiveButtonHandler={this.enableActiveButtonHandler}*/}
                            {/*                   sessionPropName="preferred-themes"*/}
                            {/*                   selectedTitle="Preselected Themes:"/>*/}
                            <div>
                              <Row>
                                <div className="col-9 my-1">
                                  Themes
                                </div>
                              </Row>
                              {
                                this.state.isLoading ?
                                    <div className="spinner-container">
                                      <Spinner animation="border" role="status">
                                        <span className="visually-hidden"></span>
                                      </Spinner>
                                      &nbsp;Loading themes relating to your chosen song books...
                                    </div>
                                    :
                                    <Row>
                                      <div className="col-md-9 my-3 col-xs-1">
                                        <select id="theme" className="dropdown-toggle btn btn-secondary"
                                                style={{width: "100%"}}
                                                onChange={e => this.changeThemeHandlerFrom(e)}>
                                          <option key="no-selection-made" className="dropdown-item">Theme ...</option>
                                          {this.getThemeOptions()}
                                        </select>
                                      </div>
                                      <div className="col-md-3 my-3 col-xs-12">
                                        <div className="btn-wrapper">
                                          <Button
                                              className="btn-icon mb-3 mb-sm-0 col-md-12 col-xs-12"
                                              color="primary"
                                              onClick={() => this.addThemeToList()}
                                              disabled={!this.addButtonAvailable()}
                                          >
                                            <RiAddLine/>
                                            <span className="btn-inner--text">Add</span>
                                          </Button>
                                        </div>
                                      </div>
                                    </Row>
                              }
                              <Row>
                                <div className="col-12 mt-3">
                                  <p>Preselected Themes:</p>
                                  {this.state.chosenThemeButtons?.length
                                      ? <span></span>
                                      : <p>No selection made</p>
                                  }
                                </div>
                                {
                                  this.state.chosenThemeButtons
                                }
                              </Row>
                            </div>
                            <Row>
                              <Col lg="2">
                                <div className="btn-wrapper">
                                </div>
                              </Col>
                              {/*<Col lg="8">*/}
                              {/*  <div className="btn-wrapper">*/}
                              {/*    <Button*/}
                              {/*        type="submit"*/}
                              {/*        id="continueButton"*/}
                              {/*        className="btn-icon mb-3 mb-sm-0 mt-5"*/}
                              {/*        color="primary"*/}
                              {/*        onClick={() => this.updateThemePreferences()}*/}
                              {/*    >*/}
                              {/*      <span className="btn-inner--text">Update Your Theme Preferences</span>*/}
                              {/*    </Button>*/}
                              {/*  </div>*/}
                              {/*</Col>*/}
                              <Col lg="2">
                                <div className="btn-wrapper">
                                </div>
                              </Col>
                            </Row>
                          </p>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        {/*</main>*/}

      </>
    );
  }
}

export default withNavigateHook((props) => (
    <YourPreferencesThemes{...props} params={useParams()}/>
));
